import ContentLoader from "react-content-loader";

const EventLoader = (props: any) => {
  return (
    <>
      <ContentLoader
        style={{ backgroundColor: "#FFFFFF", margin: "10px 15px", borderRadius: "10px" }}
        height={130}
        width={130}
        {...props}
      >
        <rect x="0" y="0" rx="8" ry="8" width="130" height="130" />
      </ContentLoader>
    </>
  );
};
export default EventLoader;
